export const DEPLOYMENT_HOST_LABEL = 'Deployment Target';
